import React from "react"

const GastronomySelected = () => (
    <div className="experiences__selected">
        <div className="container">
            <div className="has-text-white gastronomy__selected--columns">
                <div className="item--buttons">
                    <a
                        href="http://www.experiences.global/access/amexforfoodies"
                        target="_blank" rel="noreferrer"
                        className="visit-website"
                    >
                        #AMEXFORFOODIES
                    </a>

                    <a
                        href="https://go.bbva.com.ar/fgo/#/comunicaciones"
                        target="_blank" rel="noreferrer"
                        className="visit-website"
                    >
                        Experiencias BBVA GO
                    </a>
                </div>
                <div className="info px-0 mx-0">
                    <p className="pb-5">
                        We create the best dining experiences around the world.
                    </p>
                    <p className="pb-5">
                        We develop benefits on the most important hotspots of
                        every town, sommelier guided tastings, food truck
                        festivals, cooking at the chef’s private kitchen, and
                        more.
                    </p>
                </div>
            </div>
        </div>
    </div>
)

export default GastronomySelected
